import Accordion from 'accordion-js';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const containers = document.querySelectorAll(
    '.faq-carreer-block .accordion-container'
  );

  if (0 < containers.length) {
    containers.forEach((container) => {
      new Accordion(container, {
        duration: 400,
        showMultiple: true,
        openOnInit: [],
      });
    });
  }
});
